/*
* @providesModule AccountManagementEmailCellStyle
*
*/

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  Platform,
  StyleSheet,
} from 'react-native';

const {
  fontMedium,
  fontRegular,
  fontSecondary,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  container: {
    backgroundColor: '#FFF',
    paddingHorizontal: Sizes.select({
      tablet: 48,
      other: 18,
    }),
  },

  contentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
  },

  emailContainer: {
    flexDirection: 'column',
  },

  emailWithCheck: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  emailNameText: {
    ...fontSizeH4,
    ...fontMedium,
    color: 'rgb(51, 51, 51)',
    marginBottom: 4,
  },

  subTitleContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },

  subTitleText: {
    ...fontRegular,
    ...fontSizeH5,
    color: '#ACACAC',
  },

  infoButton: {
    justifyContent: 'center',
    marginLeft: 6,
  },

  infoIcon: {
    height: 25,
    width: 25,
    marginTop: -5,
  },

  verifyButton: {
    width: 72,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 1,
    borderColor: 'rgb(74, 144, 226)',
    marginLeft: 10,
    ...Platform.select({
      web: {
        boxSizing: 'content-box',
      }
    }),
  },

  verifyButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: 'rgb(74, 144, 226)',
  },

  infoModalTitle: {
    ...fontMedium,
    ...fontSizeH3,
    color: 'rgb(51, 51, 51)',
  },

  infoModalMessage: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(51, 51, 51)',
    paddingVertical: 20,
    paddingHorizontal: 40,
    textAlign: 'center',
  },

  infoModalButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    color: '#FFF',
  },

  checkBoxContainer: {
    marginRight: 24,
    height: 18,
    width: 18,
    justifyContent: 'center',
  },

  selectedCheckBox: {
    height: 16,
    width: 16,
    borderRadius: 4,
    backgroundColor: 'rgb(74, 144, 226)',
    justifyContent: 'center',
    alignItems: 'center',
  },

  unSelectedCheckBox: {
    height: 16,
    width: 16,
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderColor: 'rgb(74, 144, 226)',
  },

  bottomBorder: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(172, 172, 172, 0.2)',
  },

  flexOne: {
    flex: 1,
  },

  checkboxIcon: {
    width: 8,
    height: 6,
  },

  checkmarkIcon: {
    width: 20,
    height: 16,
  },

});
